import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_InertiaLink = _resolveComponent("InertiaLink")!
  const _component_ElTableColumn = _resolveComponent("ElTableColumn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_ElTable = _resolveComponent("ElTable")!
  const _component_ElCard = _resolveComponent("ElCard")!
  const _component_AclLayout = _resolveComponent("AclLayout")!

  return (_openBlock(), _createBlock(_component_AclLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_ElCard, null, {
        default: _withCtx(() => [
          _createVNode(_component_InertiaLink, {
            href: "/admin/dynamic_services/create",
            class: "block w-full mb-3"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                class: "w-full"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Добавить новый сервис ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ElTable, {
            data: _ctx.services,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ElTableColumn, {
                prop: "title",
                label: "Название"
              }),
              _createVNode(_component_ElTableColumn, {
                prop: "permission",
                label: "Разрешение"
              }),
              _createVNode(_component_el_table_column, {
                label: "",
                width: "250"
              }, {
                default: _withCtx(({ row }: { row: { id: Number } | any }) => [
                  _createVNode(_component_InertiaLink, {
                    href: '/admin/dynamic_services/' + row.id + '/edit',
                    class: "mr-1"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Редактировать")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["href"]),
                  _createVNode(_component_el_button, {
                    type: "danger",
                    size: "mini"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Удалить ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}